import { useNavigate, useLocation } from "react-router";
import { useEffect } from "react";

export default function RedirectionLoader() {
  const navigate = useNavigate();
  const location = useLocation();
  const state: any = location?.state;

  useEffect(() => {
    if (state?.notificationData) {
      navigate("/query", {
        state: { notificationData: state?.notificationData },
      });
    }
  }, [state]);
  return <></>;
}
